module.exports = __webpack_public_path__ + "static/media/Roberta-Rachid-1.19e67d33.jpg";